export default {
  emptyPlaceholder: 'Presuňte súbory sem na nahranie.',
  addFile: 'Pridať súbory',
  removeAllFiles: 'Odstrániť všetky súbory',
};
